import { render, staticRenderFns } from "./pay-record.vue?vue&type=template&id=35a352b4&scoped=true&"
import script from "./pay-record.vue?vue&type=script&lang=js&"
export * from "./pay-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a352b4",
  null
  
)

export default component.exports